<script lang="ts">
    import { tick } from "svelte"
    import { mdiPlus } from "@mdi/js"
    import Icon from "../widgets/Icon.svelte"
    import { scrollTo } from "svelte-scrollto"
    import { _ } from "svelte-i18n"
    import { carts, newNotification, login } from "../../store"
    import { createCart, updateCart, deleteCart, getDealer } from "../../api"
    import { requireLogin, tooltip } from "../../helper"

    import Legend from "./Carts/Legend.svelte"
    import CartView from "./Carts/Cart.svelte"
    import Modal from "../widgets/Modal.svelte"

    export let lang = "de"

    let dealer: Dealer
    let cartToDelete: Cart | null = null
    $: showConfirmDelete = cartToDelete ? true : false
    let initialScrollToCart: boolean = false

    requireLogin()

    const createNewCart = () => {
        createCart({
            name: $_("cart.createNewCartName"),
            ident: $login?.account?.ident,
            operations: [],
            deliveryAddressIsHomeAddress: true,
            customerAddress: null,
        }).then(async (response) => {
            $carts.push(response.data)
            $carts = $carts
            scrollToCart(response.data.id)

            newNotification({
                class: "success",
                html: $_("cart.createSuccessNotification"),
            })
        })
    }

    const onTitleChanged = (e: CustomEvent) => {
        let oldName = e.detail.cart.name

        let cart = e.detail.cart
        cart.name = e.detail.name

        if (cart.id) {
            updateCart(cart)
                .then(() => {
                    newNotification({
                        class: "success",
                        html: $_("cart.updateSuccess"),
                    })
                })
                .catch((e) => {
                    newNotification({
                        class: "error",
                        html: $_("cart.updateError"),
                    })
                    cart.name = oldName
                })
        } else {
            createCart(cart)
                .then(() => {
                    newNotification({
                        class: "success",
                        html: $_("cart.createSuccess"),
                    })
                })
                .catch((e) => {
                    newNotification({
                        class: "error",
                        html: $_("cart.createError"),
                    })
                    cart.name = oldName
                })
        }
    }

    const onDeleteCart = async (e: CustomEvent) => {
        cartToDelete = e.detail
        showConfirmDelete = true
    }

    const confirmedDeleteCart = async () => {
        const result = await deleteCart(cartToDelete)
        if (result) {
            $carts = $carts.filter((cart) => cart.id !== cartToDelete.id)
            cartToDelete = null

            newNotification({
                class: "success",
                html: $_("cart.deleteSuccessNotification"),
            })
        }
    }

    const getCurrentDealer = async () => {
        const response = await getDealer({
            number: $login?.account?.ident?.dealerNumber,
        })
        dealer = response.data[0]
    }

    const scrollToCart = async (id: string) => {
        await tick()
        await tick()

        scrollTo({
            element: "#cart_" + id,
        })
    }

    $: if ($login) {
        getCurrentDealer()
    }

    $: if ($carts && dealer && !initialScrollToCart) {
        initialScrollToCart = true
        scrollToCart(window.location.hash.substring(6))
    }

    let innerWidth: number
    let outerHeight: number
    let innerHeight: number
    let scrollY: number

    let pageHeight = document.documentElement.scrollHeight
    setTimeout(() => {
        pageHeight = document.documentElement.scrollHeight
    }, 1000)
</script>

<svelte:window bind:innerWidth bind:outerHeight bind:innerHeight bind:scrollY />
<section class="section_padding carts" data-lang="{lang}">
    <div class="container_wide">
        <h1 class="layout justify-content-space-between align-items-center">
            <span>{$_("cart.carts")}</span>
            <button
                class="btn btn-secondary btn-outline"
                on:click|preventDefault="{() => {
                    history.back()
                }}"
                on:keypress
            >
                &laquo; {$_("cart.back")}
            </button>
        </h1>
        {#if dealer}
            <div class="cart-list">
                {#each $carts || [] as cart (cart.id)}
                    <CartView {cart} {dealer} on:title-changed="{onTitleChanged}" on:delete-cart="{onDeleteCart}" />
                {:else}
                    <div>{$_("cart.noCartsCreated")}</div>
                {/each}
            </div>
        {/if}
        <Legend />

        <div class="main-buttons" class:on-bottom="{scrollY + innerHeight > pageHeight - 120}">
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div
                on:click="{createNewCart}"
                on:keypress
                class="create-new-cart"
                use:tooltip="{{ content: $_('cart.addCart') }}"
            >
                <Icon path="{mdiPlus}" size="24px" />
            </div>
        </div>
    </div>
</section>
{#if cartToDelete}
    <Modal
        show="{true}"
        showCloseIcon="{false}"
        on:close="{() => {
            cartToDelete = null
        }}"
    >
        <div slot="header">{$_("cart.deleteModalTitle")}</div>
        <div>
            {@html $_("cart.deleteModalMessage", { values: { cartName: cartToDelete?.name } })}
        </div>
        <div slot="footer">
            <button
                class="btn btn-secondary"
                on:click="{() => {
                    cartToDelete = null
                }}"
            >
                {$_("general.cancel")}
            </button>
            <button class="btn" on:click="{confirmedDeleteCart}">
                {$_("cart.deleteButton")}
            </button>
        </div>
    </Modal>
{/if}
